import lcRequest from '@/api/request'

import { R } from '@/api/common-types'
import { AccountDTO } from '@/api/dto/user-dto'

export interface CaptchaMathVO {
  captchaId: string
  img: string
}

export function accountLogin(account: AccountDTO) {
  return lcRequest.post<R>({
    url: '/login',
    data: account,
    showPrompt: true,
    showPromptSuccessMessage: '登录成功'
  })
}

export function getMathCaptcha() {
  return lcRequest.get<R<CaptchaMathVO>>({
    url: '/captcha/math',
    showLoading: false
  })
}

export function accountLogout() {
  return lcRequest.post<R>({
    url: '/admin/auth/logout'
  })
}
